const START_MILESTONE = {
  label: 'Hatch secured'
}

const STOP_MILESTONE = {
  label: 'Hatch open'
}

const ABORT_MILESTONE = {
  name: 'lowering_aborted',
  label: 'Aborted'
}

const MILESTONES = [
  {
    name: 'lowering_off_deck',
    label: 'Off deck'
  },
  {
    name: 'lowering_in_water',
    label: 'In water'
  },
  {
    name: 'lowering_vents_open',
    label: 'Vents opened'
  },
  {
    name: 'lowering_sub_surface',
    label: 'Sub-surface'
  },
  {
    name: 'lowering_vents_secured',
    label: 'Vents secure'
  },
  {
    name: 'lowering_on_bottom',
    label: 'On bottom'
  },
  {
    name: 'lowering_clear_to_ascend',
    label: 'Clear to ascend'
  },
  {
    name: 'lowering_off_bottom',
    label: 'Off bottom'
  },
  {
    name: 'lowering_holding_50m',
    label: 'Holding 50m'
  },
  {
    name: 'lowering_clear_to_surface',
    label: 'Clear to surface'
  },
  {
    name: 'lowering_on_surface',
    label: 'On surface'
  },
  {
    name: 'lowering_tanks_blown',
    label: 'Tanks fully blown'
  },
  {
    name: 'lowering_on_tow',
    label: 'On tow for recovery'
  },
  {
    name: 'lowering_lift_attached',
    label: 'Lift attached'
  },
  {
    name: 'lowering_on_deck',
    label: 'On deck'
  }
]

const LOWERING_DESCENT = ['lowering_sub_surface', 'lowering_on_bottom']
const LOWERING_ASCENT = ['lowering_off_bottom', 'lowering_on_surface']

module.exports = {
  START_MILESTONE,
  STOP_MILESTONE,
  ABORT_MILESTONE,
  MILESTONES,
  LOWERING_DESCENT,
  LOWERING_ASCENT
}
